import { unwrapOpsObject } from '@/features/admin/utils/opsResponse';
import { baseApi } from '@/stores/api';

import type { RoleFeatureMatrixItem, RoleFeatureMatrixPayload } from '../types/roleMatrix.types';

/**
 * Ma trận role × feature — nguồn catalog `F-xxx` từ BE (`GET /api/roles/features`).
 * `PUT` ghi `items`; BE bỏ qua các ô `role_code === admin`.
 */
function transformMatrixPayload(raw: unknown): RoleFeatureMatrixPayload {
  const o = unwrapOpsObject<RoleFeatureMatrixPayload>(raw);
  if (!o) {
    return { features: [], roles: [], items: [] };
  }
  return {
    features: Array.isArray(o.features) ? o.features : [],
    roles: Array.isArray(o.roles) ? o.roles : [],
    items: Array.isArray(o.items) ? o.items : [],
  };
}

export const roleFeatureMatrixApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRoleFeatureMatrix: builder.query<RoleFeatureMatrixPayload, void>({
      query: () => ({ url: '/api/roles/features' }),
      transformResponse: transformMatrixPayload,
      providesTags: [{ type: 'RoleFeatureMatrix', id: 'ROOT' }],
    }),
    updateRoleFeatureMatrix: builder.mutation<RoleFeatureMatrixPayload, { items: RoleFeatureMatrixItem[] }>({
      query: (body) => ({
        url: '/api/roles/features',
        method: 'PUT',
        data: body,
      }),
      transformResponse: transformMatrixPayload,
      invalidatesTags: [{ type: 'RoleFeatureMatrix', id: 'ROOT' }, 'Menu'],
    }),
  }),
});

export const { useGetRoleFeatureMatrixQuery, useUpdateRoleFeatureMatrixMutation } = roleFeatureMatrixApi;
